var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:{ 'font-weight-bold': _vm.bold },attrs:{"to":{
        name: _vm.$constants.ROUTE_NAMES.CONTACT_US_INDEX,
    }}},[_vm._v("contact us")])}
var staticRenderFns = []

export { render, staticRenderFns }